import { Component, OnInit, EventEmitter } from '@angular/core';
import { ApiRequestService } from '../../../_services/api-request.service';
import { MaterializeAction } from 'angular2-materialize';

declare var $:any;
declare var Materialize:any;

@Component({
  selector: 'app-elasticsearchform',
  templateUrl: './elasticsearchform.component.html',
  styleUrls: ['./elasticsearchform.component.css']
})
export class ElasticsearchformComponent implements OnInit {

  currentUser = JSON.parse(localStorage.getItem('currentUser'));

  Filters = {
    DoctorName:'',
    ClinicName:'',
    Email:'',
    Contact:'',
    Speciality:'',
    state:'',
    BodyPart:'',
    Treatment:'',
    Drugs:'',
    Services:'',
    Decision:'',
    Cases:''
  }

  DoctorName = this.currentUser.FirstName;
  ClinicName = this.currentUser.Company;
  Email = this.currentUser._id;
  Contact = this.currentUser.Phone;
  Speciality = this.currentUser.Department_Organization;
  state = this.currentUser.Country;
  
  BodyPart = '';
  Treatment = '';
  Drugs = '';
  Services = '';

  static BodyPart;
  static Treatment;
  static Drugs;
  static Services;

  Decision = "Choose Your Option";
  Cases = "Choose Your Option";

  Stepper = 0;

  DecisionList = ['uphold','overturn','all'];
  CasesList = [5,10,15,20,30];

  loading = false;

  Response_list;
  dataload = 1;

  FilterDataResult;
  FilterDataError;
  FilterDataCount;
  FilterDataColumn;

  FixedColumn = ["Body Part","Treatment Requested","Clinical Summary","Determination Summary","Decision Explaination","Decision Date","Case.#"];

  detail_modal = new EventEmitter<string | MaterializeAction>();

  SpecificItemDetail;


  start_dt: any = "Choose Your Option";
  end_dt: any = "Choose Your Option";

  radiolabel = true;
  radio_Option = 'caseno';
 
  constructor(private apirequest: ApiRequestService) {}

  ngOnInit() {
    
   this.getList();
   
   setTimeout(() => {
    this.md_call();
  }, 10); 
  } 

  getList(){
    let data = { action:"get_list"};
    this.apirequest.customize_flow(data).subscribe(res => {
      console.log(res);
      if(res.status === "True") {
        this.dataload = 1;
        this.Response_list = res.msg;
        this.load_data();  
      } else if(res.status === "False") {
          this.msg_view(res.msg);
      }       
    });
  }

  onBack() {
    this.Stepper = 0;
    setTimeout(() => {
      this.md_call();  
    }, 10); 
  }
  
  onNext() {
    this.Stepper = 1;
    console.log(this.Filters);
    
    setTimeout(() => {
      this.load_data();
      this.md_call();  
    }, 1000); 
  }
    
  onSubmit() {
    // radio_Option = 'caseno' 'casedate';
    console.log(this.Treatment);
    let Treatment_list = this.Treatment.split(",");
    console.log(Treatment_list);
    
    this.BodyPart = ElasticsearchformComponent.BodyPart;
    this.Treatment = ElasticsearchformComponent.Treatment;
    this.Drugs = ElasticsearchformComponent.Drugs;
    this.Services = ElasticsearchformComponent.Services;
    console.log(ElasticsearchformComponent.BodyPart);
    console.log(ElasticsearchformComponent.Treatment);
    console.log(ElasticsearchformComponent.Drugs);
    console.log(ElasticsearchformComponent.Services);
    
    this.loading = true;
    this.Filters['DoctorName'] = this.DoctorName;
    this.Filters['ClinicName'] = this.ClinicName;
    this.Filters['Email'] = this.Email;
    this.Filters['Contact'] = this.Contact;
    this.Filters['Speciality'] = this.Speciality;
    this.Filters['state'] = this.state;
    this.Filters['BodyPart'] = this.BodyPart;
    this.Filters['Treatment'] = this.Treatment;
    this.Filters['Drugs'] = this.Drugs;
    this.Filters['Services'] = this.Services;
    this.Filters['Decision'] = this.Decision;
    this.Filters['Cases'] = this.Cases;
    let data_filter;

    if(this.radio_Option === 'caseno'){
      data_filter = { 
        action:"get_search_portal_filter_new",
        body_part: this.Filters['BodyPart'] ,
        decision: this.Filters['Decision'],
        treatment: Treatment_list,
        drugs: "",
        case_no: parseInt(this.Filters['Cases']),
        services: "",
        doctorname:this.Filters['DoctorName'],
        clinicname:this.Filters['ClinicName'],
        email:this.Filters['Email'],
        contact:this.Filters['Contact'],
        speciality:this.Filters['Speciality'],
        state: this.Filters['state'],
        startdate: "",
        enddate: ""}
    } else {
      data_filter = { 
        action:"get_search_portal_filter_new",
        body_part: this.Filters['BodyPart'] ,
        decision: this.Filters['Decision'],
        treatment: Treatment_list,
        drugs: "",
        case_no: 0,
        services: "",
        doctorname:this.Filters['DoctorName'],
        clinicname:this.Filters['ClinicName'],
        email:this.Filters['Email'],
        contact:this.Filters['Contact'],
        speciality:this.Filters['Speciality'],
        state: this.Filters['state'],
        startdate: localStorage.getItem("start"),
        enddate: localStorage.getItem("end")}
    }
    

      console.log(data_filter);
      

      this.apirequest.customize_flow(data_filter).subscribe(res => {
        console.log(res);
        if(res.status === "True") {
          this.loading = false;
          // this.msg_view(res.msg);
          // this.Reset();
          // this.FilterDataResult = res.msg;
          // let col = Object.keys(res.msg[0]);
          // this.FilterDataColumn = col;
          // this.FilterDataError = res.error_values;
          // this.FilterDataCount = res.count;
          // console.log(this.FilterDataResult);          
          // console.log(this.FilterDataColumn);
          // console.log(this.FilterDataError);
          // console.log(this.FilterDataCount);
          this.Stepper = 1;      
        } else if(res.status === "False") {
          this.loading = false;
            this.msg_view(res.msg);
        }       
      });
  }

  md_call(){
    $(document).ready(function() {
      Materialize.updateTextFields();
    });
  }

  msg_view(msg_data) {
    $(document).ready(function() {
      Materialize.toast(msg_data.toString(), 3000, 'grey darken-4');
    });
  } 

  onSearchChange(searchValue: string,label) {
    if(label === 'body'){
      ElasticsearchformComponent.BodyPart = searchValue;
    }else if(label === 'treat'){
      ElasticsearchformComponent.Treatment = searchValue;
    }else if(label === 'drug'){
      ElasticsearchformComponent.Drugs = searchValue;
    }else if(label === 'service'){
      ElasticsearchformComponent.Services = searchValue;
      console.log(this.Services);     
    }  
    console.log(searchValue);
  }

  onEnter() {
    this.BodyPart = ElasticsearchformComponent.BodyPart;
    this.Treatment = ElasticsearchformComponent.Treatment;
    this.Drugs = ElasticsearchformComponent.Drugs;
    this.Services = ElasticsearchformComponent.Services;   
  } 

  load_data(){
    
    let name_1 = {};
    let name_2 = {};
    let name_3 = {};
    let name_4 = {};

    for (var i = 0; i < this.Response_list['body_parts'].length; i++) {
      name_1[this.Response_list['body_parts'][i]] = null;
    }

    // for (var i = 0; i < this.Response_list['drugs'].length; i++) {
    //   name_2[this.Response_list['drugs'][i]] = null;
    // }

    // for (var i = 0; i < this.Response_list['servies'].length; i++) {
    //   name_3[this.Response_list['servies'][i]] = null;
    // }

    // for (var i = 0; i < this.Response_list['treatments'].length; i++) {
    //   name_4[this.Response_list['treatments'][i]] = null;
    // }
        
    $('input.autocompleteBodypart').autocomplete({
      data: name_1,
      limit: 10, 
      onAutocomplete: function(val) {
        console.log(val);
        ElasticsearchformComponent.BodyPart = val;        
      },
      minLength: 1
    });


    // $('input.autocompleteTreatment').autocomplete({
    //   data: name_4,
    //   limit: 10, 
    //   onAutocomplete: function(val) {
    //     console.log(val); 
    //     ElasticsearchformComponent.Treatment = val;       
    //   },
    //   minLength: 1,
    // });

    // $('input.autocompleteDrugs').autocomplete({
    //   data: name_2,
    //   limit: 10, 
    //   onAutocomplete: function(val) {
    //     console.log(val);
    //     ElasticsearchformComponent.Drugs = val;        
    //   },
    //   minLength: 1,
    // });

    // $('input.autocompletesServices').autocomplete({
    //   data: name_3,
    //   limit: 10, 
    //   onAutocomplete: function(val) {
    //     console.log(val);  
    //     ElasticsearchformComponent.Services = val;      
    //   },
    //   minLength: 1,
    // });
    // this.Calender_init();
  }

  DetailModalOpen(item){
    console.log(item);
    this.SpecificItemDetail = item;
    this.detail_modal.emit({action: 'modal', params: ['open']});
  }

  DetailModalClose(){
    this.detail_modal.emit({action: 'modal', params: ['close']});
  }

  Reset(){
    this.getList();
    this.Filters = {
      DoctorName:'',
      ClinicName:'',
      Email:'',
      Contact:'',
      Speciality:'',
      state:'',
      BodyPart:'',
      Treatment:'',
      Drugs:'',
      Services:'',
      Decision:'',
      Cases:''
    }
  
    
    this.DoctorName = this.currentUser.FirstName;
    this.ClinicName = this.currentUser.Company;
    this.Email = this.currentUser._id;
    this.Contact = this.currentUser.Phone;
    this.Speciality = this.currentUser.Department_Organization;
    this.state = this.currentUser.Country;   
    this.BodyPart = '';
    this.Treatment = '';
    this.Drugs = '';
    this.Services = '';
  
    ElasticsearchformComponent.BodyPart;
    ElasticsearchformComponent.Treatment;
    ElasticsearchformComponent.Drugs;
    ElasticsearchformComponent.Services;
  
    this.Decision = "Choose Your Option";
    this.Cases = "Choose Your Option";
    this.Stepper = 0;
    this.loading = false;  
    this.Response_list;
    this.dataload = 1;
  
    this.FilterDataResult;
    this.FilterDataError;
    this.FilterDataCount;
    this.FilterDataColumn;
  
    this.SpecificItemDetail;
    this.start_dt = "Choose Your Option";
    this.end_dt = "Choose Your Option";
    $('#end1').val('');
    $('#start1').val('');
    this.radiolabel = true;
    this.radio_Option = 'caseno';
    localStorage.setItem('start','');
    localStorage.setItem('end','');
    setTimeout(() => {
      this.md_call();
    }, 10); 
  }

  Calender_init(){
    $("input[class*='datepicker-']").pickadate({
      selectMonths: true,
      selectYears: true,
      min: new Date(1997,3,20),
      max: new Date(2021,6,10),
      format: 'yyyy-mm-dd',
      onSet: function(obj){
        console.log(obj);
        let thisPicker = $(this)[0].$node;    // Needed to hack to get the thing I was after.
    
        // Check if this is the start date
        let classes = thisPicker.attr("class");
        if (classes === undefined || classes.length === 0 || classes.indexOf("datepicker-start") < 0){
          return;
        }
    
        // .datepicker-start must be wrapped in a div.input-field element (in this example), and
        // .datepicker-end must be in the next div.input-field.  Change selectors for your conditions.
        let parent1 = thisPicker.closest("div.input-field");    // This picker's parent
        let parent2 = parent1.next("div.input-field");          // Next picker's parent
        let picker2 = parent2.find(".datepicker-end");          // Matching 'end' picker
        
        // Set end picker minimum date, or whatever you need.
        if(obj.select){
          let dt = new Date(obj.select)
          console.log(dt);
          
          picker2.pickadate('picker').set('min', dt);
        }
    
        if(obj.hasOwnProperty('clear')){
          picker2.pickadate('picker').set('min', false);
        }
       
      },
      onClose: function(){
        $(document.activeElement).blur();
        localStorage.setItem("start",$('#start1').val());
        localStorage.setItem("end",$('#end1').val());
        console.log($('#start1').val());
        console.log($('#end1').val());
      }
    });

    $('.datepicker-start').on('mousedown', function preventClosing(event) {
      event.preventDefault();
    });
    
    $('.datepicker-end').on('mousedown', function preventClosing(event) {
      event.preventDefault();
    });
  }

  reset_calender(){
    // $("input[class*='datepicker-start']").pickadate();
    // $("#end1").pickadate("destory");
    // $("#start1").pickadate("destroy");
    var $input = $('.datepicker-start').pickadate();
    var picker = $input.pickadate('picker');
    picker.stop();
    var $input1 = $('.datepicker-end').pickadate();
    var picker1 = $input1.pickadate('picker');
    picker1.stop();
  }

  check_values(id){
  if(id === 'start'){
    this.Cases = "Choose Your Options";
    console.log("click");
     this.end_dt = "Choose Your Option";
     $('#end1').val('');
     let interval = setInterval(() => { 
             let response = this.set_value_start();
             console.log(response);           
             if(response == true) {
              clearInterval(interval);
             } 
      }, 2000);
  } else {
    this.Cases = "Choose Your Options";
    let interval = setInterval(() => { 
          let response = this.set_value_end();
          console.log(response);           
          if(response == true) {
          clearInterval(interval);
          } 
    }, 2000);
  }   
  
  }
 
  set_value_start(){
    let startdate = localStorage.getItem("start");
    console.log(startdate);
    this.start_dt = startdate;
    return true;
  }

  set_value_end(){
    let enddate = localStorage.getItem("end");
    console.log(enddate);
    this.end_dt = enddate;
    return true;
  }

  radio_check(item){
    this.radio_Option = item;
      console.log(this.radio_Option);
      if(this.radio_Option == 'casedate'){
        setTimeout(() => {
          this.Calender_init();
        }, 0.1);
      }

  }

  setCaseValues(){
    this.start_dt = '';
    this.end_dt = '';
  }

  
 
}


// WEBPACK FOOTER //
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/src/app/_components/components_user/elasticsearchform/elasticsearchform.component.ts